export default {
  SIGN_IN: 'sign-in__',
  SIGN_UP: 'sign-up__',
  AD_HEALTH_ONBOARDING_FLOW: 'ad-health-onboarding__',
};
